module.exports = __webpack_public_path__ + "media/event-access/meetup@2x-40a3b5cb.png";